import { PropsWithChildren } from "react";

export const Table = ({
  className = "",
  dataTestid,
  children,
}: {
  className?: string;
  dataTestid?: string;
} & PropsWithChildren) => (
  <div className={className}>
    <table
      className="table w-full border-separate border-spacing-y-4 md:border-collapse"
      data-testid={dataTestid}
    >
      {children}
    </table>
  </div>
);
